import moment from "moment";
import { FIELD_ICON, getTransactionColor } from "../styles/media";
import { FIELDS, CITIES, PAYMENT_METHOD, SERVICES, REVIEWS_TAGS, TRANSACTION_STATUS, TRANSACTION_TYPES } from "../utils/constants";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../shared/NormalButton";
import WorkerModalContainer from "../../containers/shared/WorkerModalContainer";
import SelectField from "../shared/SelectField";
import MultiSelect from "../shared/MultiSelect";
import GetRequestStyle from "../helpers/GetRequestStyle";
import { UserContext } from "../../App";
import RatingStars from "../shared/RatingStars";
import RequestIcon from "../icons/RequestIcon";
import { useTranslation } from "react-i18next";

const TransactionCard = ({transaction,newRequest=false,workersOptions=[],handleAddWorkerAction,forceCloseModal=false}) => {
    const {t, i18n} = useTranslation();

    const [addWorkerToRequset, setAddWorkerToRequset] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [selectedWorker, setSelectedWorker] = useState(null);

    const {fields} = useContext(UserContext);

    useEffect(()=>{
        if(moment) {
            moment?.locale('en-US');
        }
    },[])

    const getServiceName = (list,code) => {
        return SERVICES?.find(s=>s?.field?.code === transaction?.field)?.maintenanceListPerDevice?.find(m=>m?.device?.code === list)?.maintenanceList?.find(l=>l?.code === code)?.name || '-';
    }

    const handleCloseModal = () => {
        setAddWorkerToRequset(false);
    }

    const handleClickAddWorker = () => {
        setSelectedWorker(null);
        setAddWorkerToRequset(true);
    }

    useEffect(()=>{
        if(selectedWorker) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    },[selectedWorker])

    useEffect(()=>{
        if(forceCloseModal) {
            setAddWorkerToRequset(false);
        }
    },[forceCloseModal])


    return (
        <>
        <div className="w-full lg:w-[calc(33.3333%-12px)] bg-white rounded-[12px] p-[12px] relative pb-[60px]">
            <div className="flex flex-nowrap justify-between items-center pb-[12px] border-b-[1px] border-grey-200">
                <div className="w-[50%]">
                    <div className="rounded-[20px] inline-block px-[8px] py-[4px] text-[12px] font-[500]" style={{backgroundColor: getTransactionColor(transaction?.status)+'10', color: getTransactionColor(transaction?.status)}}>{TRANSACTION_STATUS[transaction?.status]?.[i18n.language === 'ar' ? 'ar' : 'en'] || TRANSACTION_STATUS[transaction?.status]?.ar}</div>
                </div>
                <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                    {transaction?.prettyId}
                </div>
            </div>

            <div className="flex flex-nowrap justify-between items-center pt-[12px] pb-[12px] border-b-[1px] border-grey-200">
                <div className="w-[50%] text-[#344854] font-[600] text-[16px]">
                   {transaction?.commissionRate ? `${t('transactions.commissionValue')} ${transaction?.commissionRate * 1000/10}%` : transaction?.customTransactionClassification?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || transaction?.customTransactionClassification?.name?.ar ? (transaction?.customTransactionClassification?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || transaction?.customTransactionClassification?.name?.ar) : transaction?.type === 'refund' ? t('transactions.refund') :''}
                </div>
                <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                    {t('transactions.date')} {moment(transaction?.createdAt).format('DD/MM/YYYY HH:mmA')}
                </div>
            </div>
            
            <div className="mt-[10px]"></div>

            {transaction?.request?.requestPrettyId && <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                <span className="text-blue text-[14px] font-[400] me-[4px]">
                    <RequestIcon />
                        {t('transactions.requestNumber')}
                </span>
                {transaction?.request?.requestPrettyId}
            </div>}

            <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                <span className="text-blue text-[14px] font-[400] me-[4px]">
                    <img src="/assets/images/worker-location-icon.svg" alt="" className="inline-block me-[3px]" />
                    {t('transactions.cityLabel')}
                </span>
                {CITIES[transaction?.city]?.[i18n.language === 'ar' ? 'ar' : 'en'] || CITIES[transaction?.city]?.ar || '-'}
            </div>

            <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                <span className="text-blue text-[14px] font-[400] me-[4px]">
                    <img src="/assets/images/worker-field.svg" alt="" className="inline-block align-sub me-[3px]" />
                    {t('transactions.details')}
                </span>
            </div>

            <div className="w-[100%] text-[14px] leading-[21px]">{transaction?.type === TRANSACTION_TYPES.commission.en ? t('transactions.commissionValue') : t('transactions.value')}: <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.worth?.toFixed(2)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>

            {transaction?.type === TRANSACTION_TYPES.commission.en && (
                <>
                <div className="w-[100%] text-[14px] leading-[21px]">{t('transactions.discountCompensation')} <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.promoCodeRefund ? transaction?.promoCodeRefund?.toFixed(2) : 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>
                <div className="w-[100%] text-[14px] leading-[21px]">{t('transactions.partsDeliveryCompensation')} <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.deliveryCostOfPartsRefund ? transaction?.deliveryCostOfPartsRefund?.toFixed(2) : 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>
                <div className="w-[100%] text-[14px] leading-[21px]">{t('transactions.collectedFromCustomerWallet')} <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.customerWalletRefund ? transaction?.customerWalletRefund?.toFixed(2) : 0 } <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>
                <div className="w-[100%] text-[14px] leading-[21px]">{t('transactions.taxValue')} <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.vatValue ? transaction?.vatValue?.toFixed(2) : 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>
                { 'incomeWorth' in transaction && <div className="w-[100%] text-[14px] leading-[21px]">{t('transactions.amountAddedToWorkerWallet')} <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.incomeWorth? transaction?.incomeWorth?.toFixed(2) : 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>}
                { 'income' in transaction && <div className="w-[100%] text-[14px] leading-[21px]">{t('transactions.workerWalletBalance')} <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.income ? transaction?.income?.toFixed(2) : 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>}
                {transaction?.donation && (<div className="w-[100%] text-[14px] leading-[21px]">{t('transactions.donationValue')} <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.donation ? transaction?.donation?.toFixed(2) : 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>)}
                </>
            )}
            {(transaction?.balance || transaction?.balance === 0) && ( <div className="w-[100%] text-[14px] leading-[21px]">{t('transactions.workerBalance')} <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.balance?.toFixed(2)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>)}
            {(transaction?.customerBalance || transaction?.customerBalance === 0) && ( <div className="w-[100%] text-[14px] leading-[21px]">{t('transactions.customerBalance')} <div className="inline-block bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[10px] leading-[25px]">{transaction?.customerBalance?.toFixed(2)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>)}
            {/* {transaction?.destinationBank && (<div className="w-[100%] text-[14px] leading-[21px]"><div className="text-center bg-gray dark:bg-dcontainer rounded-[6px] font-[600] mb-[4px] px-[5px] leading-[30px]">{transaction?.destinationBank} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div></div>)} */}


            {transaction?.memo && (<p className="bg-grey-100 rounded-[8px] px-[12px] py-[4px] mt-[10px] text-grey-900 font-[500]">{transaction?.memo}</p>)}


                


            <div className="border-t-[1px] border-grey-200 mt-[4px] absolute bottom-[12px] left-[12px] right-[12px] pt-[8px]">
               <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[3px]">
                    <path d="M6 6.375C4.415 6.375 3.125 5.085 3.125 3.5C3.125 1.915 4.415 0.625 6 0.625C7.585 0.625 8.875 1.915 8.875 3.5C8.875 5.085 7.585 6.375 6 6.375ZM6 1.375C4.83 1.375 3.875 2.33 3.875 3.5C3.875 4.67 4.83 5.625 6 5.625C7.17 5.625 8.125 4.67 8.125 3.5C8.125 2.33 7.17 1.375 6 1.375Z" fill="#344854"/>
                    <path d="M10.2951 11.375C10.0901 11.375 9.92007 11.205 9.92007 11C9.92007 9.275 8.16008 7.875 6.00008 7.875C3.84008 7.875 2.08008 9.275 2.08008 11C2.08008 11.205 1.91008 11.375 1.70508 11.375C1.50008 11.375 1.33008 11.205 1.33008 11C1.33008 8.865 3.42508 7.125 6.00008 7.125C8.57508 7.125 10.6701 8.865 10.6701 11C10.6701 11.205 10.5001 11.375 10.2951 11.375Z" fill="#344854"/>
                </svg>
               {t('transactions.createdBy')} {transaction?.createdBy ? <> {transaction?.createdBy?.name} </> : t('transactions.admin')}
                
            </div>




        </div>


        {addWorkerToRequset && <WorkerModalContainer heading={t('transactions.chooseWorker')} handleCloseModal={handleCloseModal}>
          <div className="">
            <div className="w-full">
                <div className="flex flex-nowrap justify-between items-center pb-[12px] border-b-[1px] border-grey-200">
                    <div className="w-[50%]">
                        <div className="inline-block me-[4px]">
                            {FIELD_ICON(transaction?.field,16,16,'fill-blue')}
                        </div>
                        <div className="inline-block text-blue font-[600] text-[16px] leading-[24px]">
                            {fields?.find(f=>f?.field?.code === transaction?.field)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === transaction?.field)?.field?.name?.ar}
                        </div>
                    </div>
                    <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                        {t('transactions.since')} {moment(transaction?.createdAt).format('DD/MM/YYYY')}
                    </div>
                </div>
                <div className="pt-[12px]">
                    <div className="text-center mb-[10px] h-[24px]">
                        {newRequest && <div className="inline-block bg-[#0CB450]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#0CB450] text-[12px] font-[500]">{t('transactions.new')}</div>}
                        {transaction?.customer?.activeSubscription && transaction?.customer?.activeSubscription?.status === 'active' && <div className="inline-block bg-[#FBA834]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#FBA834] text-[12px] font-[500]">{t('transactions.faniHappy')}</div>}
                        {transaction?.business?._id && <div className="inline-block bg-[#FBA834]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#FBA834] text-[12px] font-[500]">{t('transactions.faniAamal')}</div>}
                    </div>
                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            #
                             {t('transactions.requestNumberLabel')}
                        </span>
                        {transaction?.transactionPrettyId}
                    </div>
                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-name-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('transactions.customerName')}
                        </span>
                        {transaction?.customer?.name} - <span dir="ltr">{`[ ${transaction?.customer?.username} ]`}</span>
                    </div>

                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/transaction-payment-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('transactions.paymentMethod')}
                        </span>
                        {PAYMENT_METHOD[transaction?.paymentMethod]?.[i18n.language === 'ar' ? 'ar' : 'en'] || PAYMENT_METHOD[transaction?.paymentMethod]?.ar || '-'}
                    </div>

                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-city-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('transactions.cityLabel')}
                        </span>
                        {CITIES[transaction?.city]?.[i18n.language === 'ar' ? 'ar' : 'en'] || CITIES[transaction?.city]?.ar || '-'}
                    </div>

                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-location-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('transactions.districtLabel')}
                        </span>
                        {transaction?.district?.[i18n.language === 'ar' ? 'ar' : 'en'] || transaction?.district?.ar || '-'}
                    </div>

                    <div className="flex flex-nowrap bg-white px-[16px]">
                        <div className="w-[50%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500]">{t('transactions.service')}</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-center">{t('transactions.quantity')}</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-end">{t('transactions.cost')}</div>
                    </div>
                    {transaction?.maintenanceListHistory?.length > 0 ? transaction?.maintenanceListHistory?.map((item,index)=> {
                        return (<div key={'maintenanceList-'+index} className="flex flex-nowrap bg-white px-[16px] mt-[10px]">
                        <div className="w-[50%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500]">{getServiceName(item?.deviceCode,item?.maintenanceCode)}</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-center">1</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-end">{item?.cost || '0'} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                    </div>)})
                    : <div className=" bg-white px-[16px] text-center leading-[37px] text-grey-900 text-[14px] font-[500]"> {t('transactions.noServicesAvailable')} </div>}

                </div>
            </div>
            <div className="">
                <div className="mt-[20px] pt-[10px] border-t-[1px] border-grey-200">
                    <MultiSelect isMulti={false} label={t('transactions.chooseWorker')} placeholder={t('transactions.searchWorker')} options={workersOptions} value={selectedWorker} onChange={(option)=>{setSelectedWorker(option.value )}} />
                </div>
            </div>
            <div className="w-full pt-[15px] text-end">
                <NormalButton label={t('transactions.cancel')} color={'!bg-[transparent] !text-grey-400'} isDisabled={false} onClick={handleCloseModal} />
                <NormalButton label={t('transactions.assignWorker')}  isDisabled={isButtonDisabled} onClick={()=>handleAddWorkerAction(transaction?._id,selectedWorker, transaction?.business)} />
            </div>
          </div>
        </WorkerModalContainer>}

        </>
    )
}

export default TransactionCard;
